/**
 * Training method modal order: mobile / 1-on-1, group, online.
 */
export function sortTrainingMethodsForModal(methods) {
  if (!Array.isArray(methods) || methods.length === 0) return [];

  const rank = (item) => {
    const title = (item.title || '').toLowerCase();
    const path = (item.learnMoreUrl || '').toLowerCase();
    if (
      title.includes('mobile') ||
      title.includes('1-on-1') ||
      title.includes('1 on 1') ||
      path.includes('/mobile')
    ) {
      return 0;
    }
    if (title.includes('group') || path.includes('/group')) {
      return 1;
    }
    if (title.includes('online')) {
      return 2;
    }
    return (item.order ?? 99) + 10;
  };

  return [...methods].sort((a, b) => rank(a) - rank(b));
}
